dmx.Component('directions', {

    initialData: {
        routeIndex: 0,
        routes: []
    },

    attributes: {
        map: { // required
            type: String,
            default: null
        },

        start: { // required
            type: String,
            default: null
        },

        end: { // required
            type: String,
            default: null
        },

        'travel-mode': {
            type: String,
            default: 'DRIVING' // DRIVING, WALKING, BICYCLING, TRANSIT
        },

        'unit-system': {
            type: String,
            default: 'METRIC' // METRIC, IMPERIAL
        },

        'departure-time': {
            type: Date,
            default: null
        },

        'arrival-time': {
            type: Date,
            default: null
        },

        'transit-modes': {
            type: Array,
            default: null // BUS, RAIL, SUBWAY, TRAIN, TRAM
        },

        'transit-preference': {
            type: String,
            default: null // FEWER_TRANSFERS, LESS_WALKING
        },

        'provide-alternatives': {
            type: Boolean,
            default: false
        },

        'avoid-ferries': {
            type: Boolean,
            default: false
        },

        'avoid-highways': {
            type: Boolean,
            default: false
        },

        'avoid-tolls': {
            type: Boolean,
            default: false
        }
    },

    methods: {
        route: function() {
            this.route();
        },

        setRouteIndex: function(index) {
            if (this.directions) {
                this.set('routeIndex', index);
                this.renderer.setRouteIndex(index);
            }
        }
    },

    render: function(node) {
        this.service = new google.maps.DirectionsService();
        this.renderer = new google.maps.DirectionsRenderer();
        this.target = this.props.map && document.getElementById(this.props.map);
    },

    update: function(props) {
    },

    route: function() {
        var request = {
            origin: this.props.start,
            destination: this.props.end,
            travelMode: google.maps.TravelMode[this.props['travel-mode']],
            unitSystem: google.maps.UnitSystem[this.props['unit-system']],
            provideRouteAlternatives: this.props['provide-alternatives'],
            avoidFerries: this.props['avoid-ferries'],
            avoidHighways: this.props['avoid-highways'],
            avoidTolls: this.props['avoid-tolls']
        };

        if (this.props['travel-mode'] == 'TRANSIT') {
            request.transitOptions = {};

            if (this.props['arrival-time']) {
                request.transitOptions.arrivalTime = new Date(this.props['arrival-time']);
            }

            if (this.props['departure-time']) {
                request.transitOptions.departureTime = new Date(this.props['departure-time']);
            }

            if (Array.isArray(this.props['transit-modes'])) {
                request.transitOptions.modes = this.props['transit-modes'];
            }

            if (this.props['transit-preference']) {
                request.transitOptions.routingPreference = this.props['transit-preference'];
            }
        }

        if (this.props['travel-mode'] == 'DRIVING') {
            if (this.props['departure-time']) {
                request.drivingOptions.departureTime = new Date(this.props['departure-time']);
            }
        }

        this.service.route(request, this.updateRoute.bind(this));
    },

    updateRoute: function(directions, status) {
        this.set('routeIndex', 0);

        if (status == 'OK') {
            this.directions = directions;
            this.renderer.setMap(this.target.dmxComponent.map);
            this.renderer.setDirections(directions);

            this.set('routes', directions.routes.map(function(route, index) {
                return {
                    index: index,
                    copyrights: route.copyrights,
                    summary: route.summary,
                    arrivalDate: route.legs[0].arrival_time && route.legs[0].arrival_time.value.toISOString(),
                    departureDate: route.legs[0].departure_time && route.legs[0].departure_time.value.toISOString(),
                    arrival: route.legs[0].arrival_time && route.legs[0].arrival_time.text,
                    departure: route.legs[0].departure_time && route.legs[0].departure_time.text,
                    distance: route.legs[0].distance.text,
                    duration: route.legs[0].duration.text,
                    start: route.legs[0].start_address,
                    end: route.legs[0].end_address,
                    steps: route.legs[0].steps.map(function(step) {
                        var transit = {};

                        if (step.transit) {
                            transit.arrival = {
                              stop: step.transit.arrival_stop.name,
                              date: step.transit.arrival_time.value.toISOString(),
                              time: step.transit.arrival_time.text
                            };
                            transit.departure = {
                              stop: step.transit.departure_stop.name,
                              date: step.transit.departure_time.value.toISOString(),
                              time: step.transit.departure_time.text
                            };
                            transit.headsign = step.transit.headsign;
                            transit.numStops = step.transit.num_stops;
                            transit.line = step.transit.line;
                        }

                        return {
                            distance: step.distance.text,
                            duration: step.duration.text,
                            instructions: step.instructions,
                            maneuver: step.maneuver,
                            travelMode: step.travel_mode,
                            transit: transit
                        };
                    })
                }
            }));
        } else {
            console.warn(status);
            this.directions = null;
            this.set('routes', []);
        }
    }

});
